import Session from '@/api/session'
import Expert from '@/api/currentExpert'
import Platform from '@/api/platform'

const handleError = (commit, error) => {
  commit('changeLoading', { isLoading: false })
  throw error
}

export default {
  currentUser: ({ commit, dispatch }) => {
    commit('changeLoading', { isLoading: true })
    return Expert.fetch()
      .then(({ data }) => {
        commit('changeLoading', { isLoading: false })
        commit('currentUser', { user: data })
        dispatch('skiliko/chat/init', {}, { root: true })
      })
      .catch(error => handleError(commit, error))
  },
  updateCurrentUser: ({ commit }, { data }) => {
    commit('changeLoading', { isLoading: true })
    return Expert.save({ data })
      .then(({ data }) => {
        commit('changeLoading', { isLoading: false })
        commit('currentUser', { user: data })
      })
      .catch(error => handleError(commit, error))
  },
  currentPlatform: ({ commit }, { token }) => {
    commit('changeLoading', { isLoading: true })
    return Platform.fetch({ token: token.platform_token })
      .then(({ data }) => {
        commit('changeLoading', { isLoading: false })
        commit('currentPlatform', { platform: data })
      })
      .catch(error => handleError(commit, error))
  },
  reloadPlatform: ({ dispatch, getters }) => {
    const token = { platform_token: getters['currentPlatform'].token }
    return dispatch('currentPlatform', { token })
  },
  updateCurrentPlatform: ({ commit, getters }, { data }) => {
    commit('changeLoading', { isLoading: true })
    return Platform.save({ data, token: getters.currentPlatform.token })
      .then(({ data }) => {
        commit('changeLoading', { isLoading: false })
        commit('currentPlatform', { platform: data })
      })
      .catch(error => handleError(commit, error))
  },
  login: ({ commit, dispatch }, { email, password, platformName }) => {
    commit('changeLoading', { isLoading: true })
    commit('loginError', { error: null })
    return Session.login({ email, password, platformName })
      .then(({ data }) => {
        return Promise.all([
          dispatch('currentUser'),
          dispatch('currentPlatform', { token: data })
        ])
          .then(_ => commit('loginEnd', data))
      })
      .catch(error => {
        commit('loginError', { error: error.response ? error.response.data.error : error.message })
        handleError(commit, error)
      })
  },
  logout: ({ commit }) => {
    commit('changeLoading', { isLoading: true })
    return Session.logout()
      .then(_ => {
        commit('reset')
        commit('changeLoading', { isLoading: false })
      })
      .catch(error => handleError(commit, error))
  },
  connectAs: ({ commit, dispatch }, { adminId }) => {
    commit('changeLoading', { isLoading: true })
    return Session.connectAs({ adminId })
      .then(({ data }) => {
        dispatch('currentUser')
          .then(_ => commit('loginEnd', data))
      })
  }
}



// WEBPACK FOOTER //
// ./src/store/skiliko/session/actions.js